import {resources} from "../../../../../../../core/models/resource/resources";

export const listingsResourceType = resources['listings'];
export const richContentsResourceType = resources['rich-contents'];
export const baseVideosResourceType = resources['base-videos'];
export const aiVideosResourceType = resources['ai-videos'];
export const packageDesignDetailsResourceType = resources['package-design-details'];
export const rawPhotosResourceType = resources['raw-photos'];
export const rawVideosResourceType = resources['raw-videos'];
export const otherContentResourceType = resources['other-content'];
export const bannersContentResourceType = resources['banners'];
export const socialMediaContentResourceType = resources['social-media'];
export const mainPhotosResourceType = resources['main-photos'];

export const modalPath: Record<string, string> = {
  listings: listingsResourceType.path,
  richContent: richContentsResourceType.path,
  baseVideos: baseVideosResourceType.path,
  aiVideos: aiVideosResourceType.path,
  packageDesignDetails: packageDesignDetailsResourceType.path,
  rawPhotos: rawPhotosResourceType.path,
  rawVideos: rawVideosResourceType.path,
  otherContent: otherContentResourceType.path,
  banners: bannersContentResourceType.path,
  socialMedia: socialMediaContentResourceType.path,
  mainPhoto: mainPhotosResourceType.path
};

export const titleModal: Record<string, string> = {
  listings: listingsResourceType.name,
  richContent: richContentsResourceType.name,
  baseVideos: baseVideosResourceType.name,
  aiVideos: aiVideosResourceType.name,
  packageDesignDetails: packageDesignDetailsResourceType.name,
  rawPhotos: rawPhotosResourceType.name,
  rawVideos: rawVideosResourceType.name,
  otherContent: otherContentResourceType.name,
  banners: bannersContentResourceType.name,
  socialMedia: socialMediaContentResourceType.name,
  mainPhoto: mainPhotosResourceType.name
};
